export default __webpack_public_path__ + "static/7-e5e0cace31dc7cb22cc0f774a05186f9.png";